import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { GET, APIImpl } from '../api';
import { SubscriptionPlanDetailsRequest } from './subscriptionplandetailsrequest';

export class SubscriptionPlanDetailsAPI extends APIImpl<SubscriptionPlanDetailsRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/faq.json
        return "https://callertunes.etisalat.ae/en/en/ENG/faq_iosformat.json";
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/subscriptionplandetails/subscriptionplanapi.tsx